module.exports = __webpack_public_path__ + "img/EARRINGS GREEN.823aefb.svg";